const resource = 'api';
export default ($http) => ({
  getAddressData(inputAddress, city) {
    return $http.post(`${resource}/urbanos/getAddressData`, {
      address: inputAddress,
      city: city,
    });
  },
});
